import { Menu } from "antd";
import React from "react";
import { BiSolidPhoneCall } from "react-icons/bi";
import { IoPersonAddSharp, IoSettingsSharp } from "react-icons/io5";
import { MdOutlineLogout, MdPeopleAlt } from "react-icons/md";
import { PiChats } from "react-icons/pi";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { roles } from "../../config/roles";
// import { login } from "../../store/reducers/AuthSlice";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import { checkRouteName } from "../../utills";
import { GiStarsStack } from "react-icons/gi";
import "./sideMenu.css";
import { AuthMiddleware } from "../../Store/Middlewares/AuthMiddleware";
import Storage from "../../utills/AsyncStorage";
import {
  changeThemeColor,
  changeThemeFont,
  getUser,
  isLogin,
} from "../../Store/Actions/AuthAction";
import { sessionExpired } from "../../Store/Actions/GeneralActions";
function SideMenu({ collapsed, onBackClick }) {
  const dispatch = useDispatch();
  const navigation = useNavigate();
  const location = useLocation();
  const navigate = useNavigate();

  const { height, width } = useWindowDimensions();
  // const role = localStorage.getItem("@role");
  const role = Storage.getERole("@role");

  const logout = () => {
    dispatch(AuthMiddleware.logout()).then((data) => {
      dispatch(getUser(null));
      dispatch(isLogin(false));
      dispatch(sessionExpired(false));
      dispatch(changeThemeColor("#ED73AA"));
      dispatch(changeThemeFont("'Poppins', sans-serif"));
      localStorage.clear();
      navigation("/");
    });
  };

  const menuStyle = {
    borderRadius: 0,
    width: "100%",
    margin: 0,
    paddingLeft: 0,
    borderTopLeftRadius: "5px",
    borderBottomLeftRadius: "5px",
    marginBottom: 5,
    fontFamily: "var(--font-family)",
  };
  // console.log("==============================", { height, width });
  const menu = [
    {
      style: menuStyle,
      key: "Home",
      icon: (
        <div
          className="active-menu-class"
          style={{ padding: "10px", borderRadius: 5 }}
        >
          <svg
            width="21"
            height="21"
            viewBox="0 0 31 31"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_66_3608)">
              <path
                className="active-menu-class"
                d="M0.566829 8.60185C0.566829 6.46762 0.560556 4.33339 0.568397 2.19916C0.574669 0.907014 1.20036 0.268782 2.47839 0.265646C5.65386 0.257805 8.82777 0.257805 12.0032 0.265646C13.2499 0.268782 13.8756 0.886628 13.8787 2.1427C13.8897 6.43626 13.8897 10.7314 13.8787 15.0249C13.8756 16.3092 13.2499 16.9271 11.9421 16.9318C8.81993 16.9459 5.6962 16.9428 2.57404 16.9334C1.19722 16.9287 0.573101 16.2936 0.569965 14.9246C0.563692 12.817 0.566829 10.7094 0.566829 8.60185Z"
              />
              <path
                className="active-menu-class"
                d="M17.2429 22.7473C17.2429 20.9016 17.2351 19.0559 17.2461 17.2102C17.2539 15.8584 17.8545 15.2641 19.2063 15.261C22.3253 15.2547 25.4459 15.2563 28.5649 15.261C29.9433 15.2625 30.5564 15.8788 30.558 17.2666C30.5627 20.9329 30.5627 24.5977 30.558 28.264C30.5564 29.6392 29.9339 30.2523 28.5476 30.2539C25.4537 30.2586 22.3598 30.2586 19.2674 30.2539C17.8263 30.2523 17.2524 29.6706 17.2461 28.2075C17.2382 26.3869 17.2429 24.5663 17.2429 22.7473Z"
              />
              <path
                className="active-menu-class"
                d="M23.9009 0.262479C25.4879 0.262479 27.0748 0.254638 28.6633 0.265615C29.9022 0.273456 30.5498 0.910119 30.5545 2.13954C30.5655 4.76773 30.5639 7.39593 30.5545 10.0241C30.5498 11.2535 29.9147 11.9247 28.6884 11.9325C25.4879 11.9529 22.2873 11.9529 19.0867 11.9325C17.8793 11.9247 17.2536 11.2849 17.2473 10.09C17.2332 7.41004 17.2316 4.7301 17.2489 2.05015C17.2567 0.897574 17.8996 0.279728 19.0601 0.268751C20.6752 0.25307 22.2889 0.264047 23.9009 0.262479Z"
              />
              <path
                className="active-menu-class"
                d="M7.28862 20.2586C8.84735 20.2586 10.4076 20.2524 11.9664 20.2602C13.2664 20.268 13.8717 20.8671 13.8795 22.1749C13.892 24.2276 13.892 26.2818 13.8795 28.3345C13.8717 29.6424 13.2648 30.2492 11.9679 30.2524C8.79717 30.2602 5.6264 30.2602 2.45563 30.2524C1.21837 30.2492 0.577005 29.6079 0.570733 28.3753C0.559756 26.296 0.559756 24.2166 0.570733 22.1373C0.577005 20.9031 1.2168 20.268 2.45406 20.2602C4.06611 20.2492 5.67658 20.2586 7.28862 20.2586Z"
              />
            </g>
            <defs>
              <clipPath id="clip0_66_3608">
                <rect
                  width="30"
                  height="29.9984"
                  fill="white"
                  transform="translate(0.5625 0.259766)"
                />
              </clipPath>
            </defs>
          </svg>
        </div>
      ),
      label: <h4 className="menu-lable">Home</h4>,
      onClick: () => {
        navigation(
          role == roles.client
            ? "/clientHome"
            : role == roles.guest
              ? "/guestHome"
              : "/"
        );
      },
    },
    {
      style: menuStyle,
      key: "Events",
      icon: (
        <div
          className="active-menu-class"
          style={{ padding: "10px", borderRadius: 5 }}
        >
          <svg
            width="21"
            height="23"
            viewBox="0 0 31 23"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              className="active-menu-class"
              d="M30.5625 1.66121C30.5625 8.13256 30.5625 14.6039 30.5625 21.0753C30.1272 22.1836 29.2895 22.486 28.1517 22.4801C21.4756 22.4472 14.7983 22.4648 8.12226 22.4648C6.20909 22.4648 4.29592 22.4519 2.38276 22.4684C1.40264 22.4778 0.555484 21.7024 0.562544 20.6211C0.602549 14.4086 0.58137 8.1961 0.582546 1.9836C0.582546 1.13291 1.05319 0.384588 1.83916 0.321052C3.03107 0.22457 4.23709 0.296343 5.49371 0.296343C5.49371 0.819934 5.46077 1.29175 5.50077 1.75534C5.57255 2.59661 6.18674 3.13079 6.9833 3.09667C7.73868 3.06373 8.28345 2.47895 8.30698 1.6565C8.31993 1.21174 8.30934 0.76581 8.30934 0.302226C12.9122 0.302226 17.4469 0.302226 22.0615 0.302226C22.0615 0.815227 22.0333 1.28469 22.0674 1.74945C22.131 2.59779 22.731 3.13315 23.5311 3.09785C24.2912 3.0649 24.8266 2.48484 24.8466 1.65768C24.8572 1.21292 24.8489 0.766986 24.8489 0.256338C26.0232 0.256338 27.1339 0.308109 28.2376 0.242219C29.3777 0.172799 30.1696 0.55755 30.5625 1.66121ZM21.0073 19.7116C22.0321 19.7045 22.8616 18.8562 22.844 17.8349C22.8263 16.8453 21.9909 16.0135 21.0049 16.0029C19.9942 15.9923 19.1518 16.8383 19.153 17.8655C19.153 18.9079 19.9672 19.7186 21.0073 19.7116ZM26.3232 19.7104C27.348 19.7151 28.1976 18.8738 28.1905 17.8608C28.1846 16.8759 27.3504 16.0276 26.3703 16.0064C25.3666 15.9852 24.4901 16.8336 24.4712 17.8419C24.4536 18.8491 25.3019 19.7057 26.3232 19.7104ZM3.73468 14.1662C4.42653 13.4885 5.10779 13.6662 5.86434 14.0686C5.41253 13.2085 5.79963 12.6378 6.41853 12.0754C5.49371 12.1577 5.02189 11.6847 4.69832 10.8705C4.52889 11.8106 3.89235 12.0883 3.05813 12.1766C3.86058 12.6507 3.95118 13.3167 3.73468 14.1662ZM27.3798 14.0944C27.1033 13.2638 27.3575 12.6354 28.027 12.1271C27.0904 11.8695 27.0904 11.8695 26.2373 10.9094C26.0997 11.8024 25.4784 12.0883 24.6607 12.1883C25.4631 12.659 25.5231 13.3308 25.2313 14.2545C26.0102 13.6662 26.6456 13.4908 27.3798 14.0944ZM3.06637 6.9889C3.82528 7.49248 3.98177 8.13374 3.71939 8.96678C4.4277 8.44554 5.10073 8.40436 5.83022 8.93736C5.48312 8.09726 5.76904 7.48189 6.42206 6.88771C5.43018 7.06537 5.05366 6.4606 4.70891 5.61226C4.45241 6.54296 3.98177 7.01007 3.06637 6.9889ZM22.0368 8.91971C21.678 8.06432 22.0039 7.47601 22.6404 6.93242C21.7533 6.96889 21.2403 6.55943 20.9461 5.73934C20.7167 6.62415 20.126 6.94889 19.2565 7.03361C20.186 7.45013 20.0966 8.17845 19.9201 9.05737C20.6496 8.49966 21.2862 8.342 22.0368 8.91971ZM16.4927 8.98442C16.4974 7.79134 16.4974 7.79134 17.1704 6.84535C16.2244 7.0289 15.7632 6.51707 15.4266 5.7511C15.216 6.65003 14.6148 6.93595 13.7453 6.94889C14.0771 7.30658 14.4312 7.53602 14.5407 7.85017C14.6466 8.15374 14.4995 8.54673 14.4465 9.06443C15.1678 8.43612 15.8055 8.39965 16.4927 8.98442ZM8.39758 12.1754C9.30828 12.6096 9.24121 13.3343 9.13061 14.1533C9.80716 13.4791 10.4696 13.6614 11.1803 14.0733C10.8508 13.2332 11.1167 12.6284 11.7968 12.0624C10.8367 12.1989 10.4025 11.6753 10.0825 10.7458C9.81187 11.7118 9.3271 12.1695 8.39758 12.1754ZM19.9789 14.1215C20.6637 13.5956 21.3203 13.5779 22.0639 14.0838C21.6721 13.2237 22.0051 12.6378 22.6404 12.0895C21.7509 12.1354 21.2403 11.7236 20.9485 10.9035C20.7179 11.7906 20.1143 12.1001 19.2895 12.1824C20.079 12.6484 20.1672 13.312 19.9789 14.1215ZM15.4514 10.9176C15.2043 11.7859 14.6336 12.1213 13.7829 12.1566C14.5207 12.6425 14.6995 13.292 14.4889 14.1239C15.1737 13.5626 15.8173 13.5991 16.555 14.078C16.1538 13.2155 16.5244 12.639 17.1304 12.0836C16.2585 12.1154 15.7302 11.7565 15.4514 10.9176ZM3.72056 19.2845C4.4277 18.7091 5.11602 18.7915 5.85022 19.2197C5.43018 18.3596 5.82081 17.7878 6.40676 17.2254C5.46783 17.3372 5.03601 16.8089 4.70656 16.0464C4.51242 16.9312 3.90882 17.2525 3.07696 17.3466C3.8394 17.8313 3.97118 18.4644 3.72056 19.2845ZM11.1532 19.2292C10.8285 18.3726 11.1473 17.7843 11.7839 17.236C10.8743 17.3101 10.3849 16.8677 10.0895 16.0641C9.83187 16.8936 9.28592 17.2889 8.39288 17.3607C9.32475 17.7702 9.22474 18.5032 9.05413 19.4104C9.80598 18.7491 10.4425 18.715 11.1532 19.2292ZM17.181 17.1724C16.2362 17.3031 15.7408 16.8724 15.4172 16.0417C15.2784 17.0348 14.5665 17.203 13.79 17.3548C14.5901 17.8078 14.643 18.4832 14.4854 19.2833C15.1654 18.7173 15.8185 18.775 16.4785 19.2633C16.5209 18.0549 16.5209 18.0549 17.181 17.1724ZM26.302 5.7464C26.0891 6.6465 25.4831 6.93007 24.6595 7.00537C25.3961 7.49837 25.582 8.13021 25.3125 8.99266C26.0138 8.37612 26.688 8.46083 27.4139 8.92089C27.108 8.09373 27.3222 7.47131 28.0105 6.9383C27.1363 6.95124 26.5891 6.58649 26.302 5.7464ZM11.1744 8.92089C10.8755 8.09373 11.0885 7.47248 11.7662 6.93712C10.8732 6.96419 10.3684 6.54178 10.0825 5.73934C9.83422 6.5912 9.28239 6.9736 8.41876 7.01713C9.20356 7.49131 9.31181 8.15138 9.11296 8.9656C9.80363 8.41848 10.4625 8.43612 11.1744 8.92089Z"
            />
          </svg>
        </div>
      ),
      label: <h4 className="menu-lable">Events</h4>,
      onClick: () => {
        navigation(role == roles.guest ? "/guestEvents" : "/events");
      },
    },
    {
      style: menuStyle,
      key: "Advertisement",
      icon: (
        <div
          className="active-menu-class"
          style={{ padding: "10px", borderRadius: 5 }}
        >
          <svg
            width="25"
            height="25"
            viewBox="0 0 33 31"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_66_3526)">
              <path
                className="active-menu-class"
                d="M12.6882 7.20788C16.842 6.31816 20.112 3.98361 23.2979 1.47191C23.9329 0.971934 24.7163 0.53757 25.4984 0.357788C27.1588 -0.0227728 28.4155 1.07429 28.4169 2.74613C28.4195 9.56473 28.3701 16.3846 28.4463 23.2019C28.4703 25.3383 26.6923 26.0443 25.2177 25.6821C24.5773 25.5247 23.9636 25.148 23.4128 24.7675C21.5866 23.5011 19.8727 22.0589 17.9636 20.9304C16.4824 20.0551 14.7698 19.5564 13.1709 18.8675C12.977 18.7835 12.7096 18.5552 12.7083 18.3924C12.6816 14.6905 12.6882 10.9899 12.6882 7.20788Z"
              />
              <path
                className="active-menu-class"
                d="M9.93876 7.7002C9.93876 11.2342 9.93876 14.7051 9.93876 18.2207C9.14865 18.1682 8.404 18.1079 7.65801 18.0738C6.10721 18.0029 4.55507 17.9583 3.0056 17.8822C1.54972 17.81 0.678061 16.9308 0.660682 15.4938C0.639291 13.818 0.633944 12.1409 0.660682 10.4652C0.680735 9.01772 1.55774 8.17786 3.01897 8.09913C4.81175 8.00202 6.60453 7.88129 8.39731 7.77368C8.89999 7.7435 9.40266 7.72513 9.93876 7.7002Z"
              />
              <path
                className="active-menu-class"
                d="M8.86787 30.275C8.53499 30.2736 8.2021 30.292 7.87055 30.271C7.14862 30.2251 6.61654 29.9141 6.34381 29.2173C5.6513 27.4536 4.92269 25.7043 4.25156 23.934C3.74755 22.6034 3.80504 21.1992 3.85183 19.8095C3.85584 19.6783 4.14327 19.4421 4.29167 19.4474C5.57376 19.4946 6.85317 19.5983 8.13392 19.6586C8.4922 19.6757 8.65664 19.7846 8.65664 20.1547C8.65664 21.6769 9.15263 23.0443 9.98686 24.3198C10.5724 25.2148 11.1072 26.1452 11.6406 27.0717C12.5577 28.6661 11.5992 30.2632 9.73151 30.2736C9.44408 30.2776 9.15531 30.2763 8.86787 30.275Z"
              />
              <path
                className="active-menu-class"
                d="M30.082 16.7374C30.082 14.2467 30.082 11.8203 30.082 9.39258C31.32 9.57105 32.4376 11.1576 32.6088 12.4817C32.8387 14.2638 31.7893 16.0839 30.082 16.7374Z"
              />
            </g>
            <defs>
              <clipPath id="clip0_66_3526">
                <rect
                  className="active-menu-class"
                  width="32"
                  height="30"
                  transform="translate(0.640625 0.28125)"
                />
              </clipPath>
            </defs>
          </svg>
        </div>
      ),
      label: <h4 className="menu-lable">Advertisement</h4>,
      onClick: () => {
        navigate("/Advertisement");
      },
    },
    {
      style: menuStyle,
      key: "Templates",
      icon: (
        <div
          className="active-menu-class"
          style={{ padding: "10px", borderRadius: 5 }}
        >
          <svg
            width="23"
            height="24"
            viewBox="0 0 26 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              className="active-menu-class"
              d="M24.6893 6.66699H1.51892C1.05345 6.66699 0.691406 6.30496 0.691406 5.83948V0.874393C0.691406 0.408916 1.05345 0.046875 1.51892 0.046875H24.6893C25.1548 0.046875 25.5168 0.408916 25.5168 0.874393V5.83948C25.5168 6.30496 25.1548 6.66699 24.6893 6.66699Z"
            />
            <path
              className="active-menu-class"
              d="M11.4491 14.9424H1.51892C1.05345 14.9424 0.691406 14.5804 0.691406 14.1149V9.14978C0.691406 8.68431 1.05345 8.32227 1.51892 8.32227H11.4491C11.9146 8.32227 12.2766 8.68431 12.2766 9.14978V14.1149C12.2766 14.5804 11.9146 14.9424 11.4491 14.9424Z"
            />
            <path
              className="active-menu-class"
              d="M24.6893 14.9424H14.7592C14.2937 14.9424 13.9316 14.5804 13.9316 14.1149V9.14978C13.9316 8.68431 14.2937 8.32227 14.7592 8.32227H24.6893C25.1548 8.32227 25.5168 8.68431 25.5168 9.14978V14.1149C25.5168 14.5804 25.1548 14.9424 24.6893 14.9424Z"
            />
            <path
              className="active-menu-class"
              d="M6.48401 23.2178H1.51892C1.05345 23.2178 0.691406 22.8557 0.691406 22.3903V17.4252C0.691406 16.9597 1.05345 16.5977 1.51892 16.5977H6.48401C6.94948 16.5977 7.31152 16.9597 7.31152 17.4252V22.3903C7.31152 22.8557 6.94948 23.2178 6.48401 23.2178Z"
            />
            <path
              className="active-menu-class"
              d="M16.4144 23.2178H9.79431C9.32884 23.2178 8.9668 22.8557 8.9668 22.3903V17.4252C8.9668 16.9597 9.32884 16.5977 9.79431 16.5977H16.4144C16.8799 16.5977 17.2419 16.9597 17.2419 17.4252V22.3903C17.2419 22.8557 16.8799 23.2178 16.4144 23.2178Z"
            />
            <path
              className="active-menu-class"
              d="M24.6891 23.2178H19.724C19.2585 23.2178 18.8965 22.8557 18.8965 22.3903V17.4252C18.8965 16.9597 19.2585 16.5977 19.724 16.5977H24.6891C25.1546 16.5977 25.5166 16.9597 25.5166 17.4252V22.3903C25.5166 22.8557 25.1546 23.2178 24.6891 23.2178Z"
            />
          </svg>
        </div>
      ),
      label: <h4 className="menu-lable">{role == roles.client ? "Templates" : "Planning Forms"}</h4>,
      onClick: () => {
        navigation(
          role == roles.client ? "/templates" : "/templates/mytemplates",
          {
            state: { eventData: { id: false }, headrTitle: role == roles.client ? "Templates" : "Planning Forms" },
          }
        );
      },
    },
    // {
    //   style: menuStyle,
    //   key: "Reminder",
    //   icon: (
    //     <div
    //       className="active-menu-class"
    //       style={{ padding: "10px", borderRadius: 5 }}
    //     >
    //       {/* <AiOutlineFileDone size={20} className="active-menu-class" /> */}
    //       <svg
    //         width="25"
    //         height="25"
    //         viewBox="0 0 32 33"
    //         fill="none"
    //         xmlns="http://www.w3.org/2000/svg"
    //       >
    //         <path
    //           className="active-menu-class"
    //           d="M24.2372 26.9163C24.1085 26.6967 24.1481 26.5849 24.3158 26.4209C26.9237 23.8629 28.204 20.7105 28.2638 17.4932C28.2586 15.8966 28.1253 14.7947 27.8368 13.7169C25.6896 5.69763 17.101 1.86172 9.94658 5.72441C5.49108 8.12971 2.82792 13.3373 3.44075 18.4619C3.81637 21.6076 5.11611 24.2767 7.36985 26.441C7.54077 26.6056 7.54921 26.7114 7.43159 26.9089C6.88895 27.8187 6.36256 28.7385 5.83291 29.6563C5.19344 30.7629 5.48133 32.0569 6.50423 32.6795C7.52777 33.3027 8.76967 32.9386 9.39744 31.8273C9.90174 30.9336 10.4054 30.0385 10.8986 29.1381C10.9968 28.9594 11.0806 28.9233 11.2749 28.9996C14.2981 30.1932 17.3252 30.1939 20.3477 28.9996C20.5433 28.9226 20.6272 28.9708 20.7233 29.1455C21.2192 30.0446 21.7248 30.9383 22.2304 31.832C22.8595 32.9419 24.0988 33.3021 25.1262 32.6768C26.1348 32.0636 26.4279 30.7783 25.8086 29.6797C25.288 28.7566 24.7733 27.8301 24.2372 26.9163ZM22.0497 19.5638C20.0182 19.766 17.9861 19.9654 15.9533 20.1529C14.5554 20.2814 13.5202 19.2612 13.5423 17.7436C13.658 16.1115 13.7769 14.4251 13.8958 12.7381C13.9719 11.6617 14.0589 10.5859 14.122 9.50876C14.1805 8.49924 14.9239 7.74143 15.8818 7.74411C16.8248 7.74679 17.5643 8.50125 17.6287 9.48935C17.7534 11.41 17.8964 13.3293 18.0251 15.2499C18.0394 15.4621 18.0979 15.5511 18.3253 15.5719C19.562 15.6877 20.7968 15.8256 22.0322 15.9548C22.94 16.0499 23.6205 16.8151 23.6295 17.7509C23.638 18.6728 22.9504 19.4741 22.0497 19.5638Z"
    //         />
    //         <path
    //           className="active-menu-class"
    //           d="M31.3635 6.90288C31.3434 8.60058 30.7305 10.0325 29.5374 11.2067C29.3502 11.3908 29.2781 11.3848 29.1702 11.1311C27.632 7.50671 25.104 4.88719 21.598 3.27785C21.299 3.14061 21.3497 3.04823 21.5343 2.85945C23.1966 1.15304 25.1729 0.555898 27.4084 1.29496C29.6238 2.028 30.9197 3.66546 31.3148 6.0393C31.3349 6.1598 31.3557 6.28097 31.3616 6.4028C31.37 6.56883 31.3635 6.73619 31.3635 6.90288Z"
    //         />
    //         <path
    //           className="active-menu-class"
    //           d="M0.368415 7.02684C0.355418 4.53116 1.78058 2.35882 3.95114 1.46578C6.11195 0.576764 8.62109 1.1478 10.2087 2.87496C10.4212 3.10592 10.3692 3.16684 10.1125 3.28399C6.63769 4.86923 4.11815 7.44993 2.55782 11.0214C2.53572 11.0723 2.50973 11.1211 2.49413 11.174C2.4285 11.3963 2.34336 11.3862 2.18805 11.2356C1.46734 10.5334 0.946798 9.7026 0.64006 8.73124C0.455498 8.14614 0.354768 7.54566 0.368415 7.02684Z"
    //         />
    //       </svg>
    //     </div>
    //   ),
    //   label: <h4 className="menu-lable">Reminder</h4>,
    //   onClick: () => {
    //     navigate("/reminder");
    //   },
    // },
    {
      style: menuStyle,
      key: "Membership",
      icon: (
        <div
          className="active-menu-class"
          style={{ padding: "10px", borderRadius: 5 }}
        >
          <svg
            width="25"
            height="25"
            viewBox="0 0 31 31"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              className="active-menu-class"
              d="M9.70703 30.7676C9.70703 28.1877 9.70703 25.6078 9.70703 22.9883C11.4448 22.9883 13.1303 22.9883 14.9166 22.9883C14.9166 23.4278 14.9166 23.8623 14.9166 24.2968C14.9166 25.5043 14.9013 26.7118 14.9256 27.9193C14.9333 28.3116 14.8183 28.5135 14.4439 28.6771C12.8977 29.3518 11.3695 30.0673 9.83481 30.7688C9.79137 30.7676 9.7492 30.7676 9.70703 30.7676Z"
            />
            <path
              className="active-menu-class"
              d="M21.2893 30.7676C19.7942 30.0827 18.3069 29.3787 16.7978 28.7244C16.3441 28.5276 16.1793 28.2951 16.1921 27.7891C16.2304 26.2059 16.2061 24.6214 16.2061 22.9922C17.9504 22.9922 19.6345 22.9922 21.4158 22.9922C21.4158 25.5785 21.4158 28.1724 21.4158 30.7676C21.3749 30.7676 21.3327 30.7676 21.2893 30.7676Z"
            />
            <path
              className="active-menu-class"
              d="M15.5614 21.6344C11.1708 21.6344 6.7803 21.6344 2.39104 21.6344C0.956064 21.6332 0.5625 21.2447 0.5625 19.8353C0.5625 14.066 0.5625 8.29798 0.5625 2.52869C0.5625 1.22277 1.00334 0.784481 2.32715 0.783203C11.1517 0.783203 19.9736 0.783203 28.7969 0.784481C30.1207 0.784481 30.5615 1.22405 30.5615 2.52996C30.5628 8.3197 30.5628 14.1094 30.5615 19.9005C30.5615 21.2179 30.136 21.6344 28.7956 21.6344C24.3846 21.6357 19.9724 21.6344 15.5614 21.6344ZM19.1776 16.4133C18.977 15.1623 18.83 14.0302 18.6 12.916C18.4876 12.3716 18.6153 12.0164 19.0076 11.642C19.8114 10.8753 20.5653 10.055 21.4176 9.17711C20.348 9.0161 19.4152 8.82699 18.4735 8.74777C17.6774 8.68132 17.1574 8.41042 16.9031 7.59391C16.7037 6.95373 16.346 6.3621 16.0559 5.75131C15.9089 5.44208 15.7543 5.13541 15.5537 4.72396C14.9838 5.93404 14.4689 6.99973 13.9833 8.0782C13.83 8.41809 13.646 8.59571 13.2473 8.64554C12.1036 8.78866 10.9689 8.9931 9.71926 9.19116C10.6176 10.1163 11.4315 10.9699 12.2659 11.803C12.5291 12.0649 12.6275 12.3026 12.5534 12.6924C12.326 13.8897 12.1586 15.0985 11.9503 16.4197C13.0786 15.8 14.1047 15.2582 15.1078 14.6742C15.4451 14.4787 15.6968 14.48 16.0316 14.6742C17.0321 15.2531 18.0544 15.7961 19.1776 16.4133Z"
            />
          </svg>
        </div>
      ),
      label: (
        <h4
          className="menu-lable"
          style={{ margin: 0, padding: 0, lineHeight: 1 }}
        >
          Subscription
        </h4>
      ),
      onClick: () => {
        navigate("/membership");
      },
    },
    {
      style: menuStyle,
      key: "Reviews",
      icon: (
        <div
          className="active-menu-class"
          style={{ padding: "10px", borderRadius: 5 }}
        >
          <svg
            width="25"
            height="25"
            viewBox="0 0 34 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              className="active-menu-class"
              d="M0.9176 27.649C1.00168 27.9904 1.00041 28.3439 1.10346 28.6841C1.66292 30.5319 3.50251 31.4667 4.91919 31.4613C11.6934 31.4329 18.4677 31.4214 25.2413 31.4667C27.0405 31.4788 29.2492 30.0552 29.2625 27.669C29.2764 25.2266 29.265 22.7848 29.2669 20.3424C29.2669 20.2058 29.2398 20.0953 29.131 19.9919C27.8762 18.8016 26.6258 17.6063 25.3734 16.4129C25.3444 16.3857 25.309 16.3646 25.2723 16.3374C25.1787 16.4528 25.2224 16.5773 25.2224 16.6915C25.2198 20.2089 25.2154 23.7268 25.2274 27.2442C25.2287 27.5499 25.1465 27.6261 24.8273 27.6255C18.3482 27.6164 11.8692 27.6164 5.39015 27.6255C5.07786 27.6261 4.98304 27.5614 4.98367 27.2472C4.99442 21.0663 4.99126 14.8854 4.99126 8.70447C4.99126 8.32197 4.99126 8.32137 5.40975 8.32137C9.08641 8.32137 12.7631 8.32137 16.4404 8.32137C16.563 8.32137 16.6856 8.32137 16.8209 8.32137C16.7786 8.17575 16.6831 8.12197 16.611 8.05308C15.4352 6.92917 14.2562 5.80828 13.0836 4.68134C12.935 4.53814 12.7915 4.45535 12.5665 4.45596C10.0802 4.46381 7.59387 4.45354 5.10757 4.46321C2.99868 4.47167 1.38856 5.73758 1.00863 7.66757C0.968171 7.87362 0.947942 8.0833 0.9176 8.29116C0.9176 14.7434 0.9176 21.1962 0.9176 27.649Z"
            />
            <path
              className="active-menu-class"
              d="M20.1342 0.571425C20.033 0.591366 19.9319 0.611306 19.8314 0.630641C19.2384 0.746659 18.8167 1.0645 18.6195 1.61497C18.4286 2.14974 18.6119 2.59145 19.0209 2.97938C20.3067 4.19695 21.5787 5.42842 22.8721 6.63874C23.0914 6.84419 23.0434 6.93905 22.8563 7.1167C19.8351 9.98993 16.8191 12.8692 13.805 15.7497C13.2752 16.2561 12.784 16.7938 12.4439 17.4392C11.9287 18.4181 12.0943 19.2888 12.9439 20.0955C13.7986 20.9076 14.702 21.0629 15.7293 20.5698C16.3867 20.2544 16.9386 19.8024 17.4538 19.3118C20.4888 16.4228 23.5213 13.5315 26.5481 10.6347C26.7396 10.4516 26.8401 10.4208 27.0494 10.625C28.2669 11.8087 29.5022 12.9749 30.7311 14.1472C31.6465 15.0197 32.7332 14.8119 33.2288 13.6698C33.2402 13.6433 33.2635 13.6209 33.2812 13.5967C33.2812 9.8576 33.2812 6.11848 33.2812 2.37935C33.2458 2.29838 33.2079 2.21862 33.1757 2.13644C32.8691 1.34729 32.2818 0.859049 31.4315 0.65481C31.271 0.616139 31.1053 0.598011 30.9422 0.570215C27.3408 0.571425 23.7375 0.571425 20.1342 0.571425Z"
            />
          </svg>
        </div>
      ),
      label: <h4 className="menu-lable">Reviews</h4>,
      onClick: () => {
        navigation("/reviews");
      },
    },
    {
      style: menuStyle,
      key: "Settings",
      icon: (
        <div
          className="active-menu-class"
          style={{ padding: "10px", borderRadius: 5 }}
        >
          <IoSettingsSharp size={25} className="active-menu-class" />
        </div>
      ),
      label: <h4 className="menu-lable">Setting</h4>,
      onClick: () => {
        navigate(
          role == roles.client ? "/settings" : "/settings/ChangePassword"
        );
      },
    },
    {
      style: menuStyle,
      key: "Contact Us",
      icon: (
        <div
          className="active-menu-class"
          style={{ padding: "10px", borderRadius: 5 }}
        >
          <BiSolidPhoneCall size={25} className="active-menu-class" />
        </div>
      ),
      label: <h4 className="menu-lable">Contact Us</h4>,
      onClick: () => {
        navigation("/contactUs");
      },
    },
    {
      style: menuStyle,
      key: "About Us",
      icon: (
        <div
          className="active-menu-class"
          style={{ padding: "10px", borderRadius: 5 }}
        >
          <MdPeopleAlt size={25} className="active-menu-class" />
        </div>
      ),
      label: <h4 className="menu-lable">About us</h4>,
      onClick: () => {
        navigation("/aboutUs");
      },
    },
    {
      style: menuStyle,
      key: "Terms And Conditions",
      icon: (
        <div
          className="active-menu-class"
          style={{ padding: "10px", borderRadius: 5 }}
        >
          <svg
            width="25"
            height="25"
            viewBox="0 0 31 31"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              className="active-menu-class"
              d="M30.5625 22.5555C30.5075 22.7432 30.4465 22.9298 30.3963 23.1199C29.692 25.7913 27.2083 27.4391 24.4245 27.0816C21.8847 26.7551 19.8494 24.391 19.8614 21.7794C19.8733 19.1296 21.9098 16.8169 24.513 16.4953C27.249 16.1568 29.7589 17.8883 30.4214 20.5657C30.4585 20.7152 30.5147 20.8599 30.5613 21.0082C30.5625 21.5235 30.5625 22.0389 30.5625 22.5555ZM25.7518 21.2545C25.7518 20.1639 25.7566 19.1726 25.7494 18.1801C25.747 17.8286 25.6107 17.4961 25.2101 17.5643C25.014 17.5978 24.7235 17.8919 24.7163 18.0773C24.6732 19.187 24.6768 20.3003 24.7163 21.4099C24.7342 21.9265 25.0953 22.2793 25.5988 22.2996C26.7288 22.345 27.8612 22.3391 28.9912 22.2972C29.161 22.2912 29.4468 21.9863 29.4492 21.8141C29.4528 21.6359 29.2065 21.4099 29.0163 21.2868C28.8884 21.2031 28.6696 21.2557 28.4914 21.2545C27.6029 21.2533 26.7144 21.2545 25.7518 21.2545Z"
            />
            <path
              className="active-menu-class"
              d="M26.2317 15.4261C22.068 14.9167 18.9219 18.0054 18.788 21.6394C18.6744 24.7054 21.3099 28.7113 26.2736 28.1828C26.2736 28.7388 26.3142 29.2937 26.2509 29.8354C26.2293 30.0207 25.9711 30.2324 25.7714 30.328C25.592 30.4141 25.3433 30.3627 25.1256 30.3627C18.7353 30.3639 12.3451 30.3639 5.95595 30.3639C4.95867 30.3639 4.87974 30.2838 4.87974 29.2745C4.87855 27.7667 4.87855 26.2576 4.88094 24.7497C4.88094 24.5584 4.89888 24.367 4.90366 24.2618C5.68571 24.5069 6.44981 24.7306 7.20197 24.9924C7.39449 25.0594 7.52842 25.3081 7.71974 25.3619C7.95053 25.4277 8.31046 25.4731 8.43961 25.3476C8.56516 25.2256 8.52092 24.8621 8.45754 24.6301C8.35829 24.2678 8.1861 23.9258 8.03543 23.5778C7.76877 22.9656 7.50689 22.3509 7.21871 21.7495C7.1362 21.5761 6.97237 21.4409 6.84084 21.2927C6.19392 20.5704 5.29229 19.9462 4.96584 19.1008C4.63939 18.253 4.88094 17.1839 4.88094 16.2118C4.87974 11.2899 4.87974 6.36923 4.88094 1.44736C4.88094 0.47997 4.96465 0.397461 5.92845 0.397461C10.1747 0.397461 14.4221 0.397461 18.6684 0.397461C18.8645 0.397461 19.0606 0.397461 19.3404 0.397461C19.3404 0.647381 19.3404 0.859035 19.3404 1.06949C19.3404 2.57738 19.332 4.08647 19.344 5.59436C19.3536 6.71242 19.9574 7.32944 21.0743 7.34021C22.7783 7.35695 24.4823 7.34499 26.2341 7.34499C26.2317 10.0535 26.2317 12.7165 26.2317 15.4261ZM15.6143 11.1057C18.1327 11.1057 20.651 11.1057 23.1693 11.1057C23.3284 11.1057 23.5316 11.1607 23.6345 11.083C23.8294 10.9359 24.065 10.7255 24.0925 10.515C24.1104 10.3811 23.7971 10.1838 23.6058 10.0535C23.5233 9.99725 23.3738 10.0403 23.2554 10.0403C18.1398 10.0403 13.0243 10.0403 7.90868 10.0403C7.79029 10.0403 7.63962 9.99725 7.55831 10.0535C7.36698 10.185 7.08239 10.3548 7.07162 10.5258C7.05967 10.704 7.29285 10.9431 7.477 11.0735C7.59897 11.1596 7.82258 11.1057 8.00075 11.1057C10.5382 11.1057 13.0769 11.1045 15.6143 11.1057ZM15.5498 13.7628C16.7192 13.7628 17.8899 13.7628 19.0594 13.7628C20.5266 13.7628 21.9939 13.7604 23.4611 13.764C23.8198 13.7652 24.1104 13.6623 24.1236 13.2558C24.1367 12.8528 23.8533 12.7177 23.4982 12.6949C23.3595 12.6866 23.2207 12.6914 23.082 12.6914C18.0657 12.6914 13.0494 12.6902 8.03304 12.6914C7.83573 12.6914 7.59179 12.6471 7.45308 12.7428C7.27132 12.8683 7.07641 13.1111 7.07162 13.3084C7.06804 13.4531 7.34068 13.6396 7.52722 13.7413C7.65039 13.8082 7.83812 13.7604 7.99597 13.7604C10.5131 13.7616 13.0314 13.7616 15.5498 13.7628ZM13.4129 16.4593C15.1779 16.4593 16.9429 16.4593 18.709 16.4581C18.8872 16.4581 19.106 16.5095 19.234 16.4258C19.4253 16.3014 19.674 16.0802 19.674 15.8997C19.674 15.7322 19.399 15.5385 19.2089 15.407C19.1132 15.3412 18.9386 15.3867 18.7999 15.3867C15.1707 15.3867 11.5403 15.3855 7.91107 15.3867C7.75322 15.3867 7.5619 15.3472 7.44471 15.4201C7.27969 15.523 7.07641 15.7071 7.06325 15.8698C7.0501 16.0336 7.21153 16.2715 7.36459 16.3732C7.50928 16.4701 7.74366 16.4533 7.93857 16.4533C9.76334 16.4605 11.5881 16.4581 13.4129 16.4593ZM12.5172 19.1151C14.1053 19.1151 15.6933 19.1115 17.2801 19.1175C17.6723 19.1187 18.0442 19.0601 18.0358 18.5818C18.0286 18.1155 17.6567 18.0425 17.2669 18.0425C14.1112 18.0449 10.9555 18.0449 7.79986 18.0425C7.40405 18.0425 7.04173 18.1274 7.04412 18.5938C7.04651 19.0733 7.42319 19.1199 7.81301 19.1187C9.38189 19.1115 10.9496 19.1151 12.5172 19.1151ZM12.6356 26.6091C11.227 26.6091 9.81835 26.6115 8.40852 26.6079C8.01271 26.6067 7.59179 26.6151 7.58223 27.1377C7.57266 27.6638 7.98521 27.683 8.38699 27.683C11.2246 27.6794 14.0622 27.6806 16.8998 27.683C17.3028 27.683 17.707 27.659 17.6962 27.1281C17.6854 26.6426 17.304 26.6067 16.9213 26.6079C15.4936 26.6115 14.0646 26.6091 12.6356 26.6091ZM13.1737 21.8092C14.3635 21.8092 15.5533 21.8128 16.742 21.8069C17.1509 21.8045 17.6711 21.8822 17.6902 21.2819C17.7106 20.6565 17.1844 20.7414 16.7766 20.7402C14.9327 20.7354 13.0888 20.7378 11.2449 20.7378C10.5705 20.7378 9.89368 20.7031 9.22524 20.7617C9.01956 20.7797 8.8378 21.0571 8.64528 21.2149C8.82704 21.4099 8.98608 21.6347 9.19893 21.7865C9.30536 21.8631 9.50744 21.808 9.66529 21.808C10.8348 21.8104 12.0043 21.8104 13.1737 21.8092Z"
            />
            <path
              className="active-menu-class"
              d="M25.2563 6.27197C23.8824 6.27197 22.4366 6.2923 20.9933 6.24806C20.7948 6.24208 20.4457 5.91682 20.4409 5.73028C20.3942 4.26783 20.4146 2.80419 20.4146 1.43262C22.0109 3.0278 23.6348 4.65168 25.2563 6.27197Z"
            />
            <path
              className="active-menu-class"
              d="M2.75873 18.4512C3.92462 19.7187 5.1515 21.0102 6.31979 22.353C6.65341 22.7369 6.81484 23.269 7.05519 23.7342C6.99541 23.7999 6.93681 23.8657 6.87702 23.9303C6.41664 23.6732 5.86897 23.5034 5.51263 23.1434C4.25825 21.8819 3.06963 20.5558 1.85352 19.2512C2.15964 18.9797 2.43586 18.7358 2.75873 18.4512Z"
            />
            <path
              className="active-menu-class"
              d="M2.04536 17.4659C1.63521 17.8725 1.38289 18.1224 1.00861 18.4931C0.828048 18.0805 0.637918 17.7577 0.563779 17.4085C0.539863 17.2961 0.857943 16.9744 0.965564 16.9983C1.29799 17.0701 1.60292 17.2614 2.04536 17.4659Z"
            />
          </svg>
        </div>
      ),
      label: <h4 className="menu-lable">Terms & Conditions</h4>,
      onClick: () => {
        navigation("/termsAndConditions", {
          state: { headrTitle: "Terms & Conditions" },
        });
      },
    },
    {
      style: menuStyle,
      key: "Privacy Policy",
      icon: (
        <div
          className="active-menu-class"
          style={{ padding: "10px", borderRadius: 5 }}
        >
          <svg
            width="25"
            height="25"
            viewBox="0 0 31 33"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              className="active-menu-class"
              d="M0.564026 9.2769C0.564026 7.96964 0.564026 6.70529 0.564026 5.44228C0.564026 4.17391 0.558662 2.90554 0.568048 1.63717C0.574752 0.649017 1.00648 0.185109 1.98256 0.183768C8.76822 0.175723 15.5552 0.175723 22.3409 0.183768C23.2365 0.185109 23.7313 0.627564 23.738 1.44946C23.7567 3.9862 23.7433 6.52295 23.7406 9.05835C23.7406 9.12003 23.7085 9.1817 23.683 9.2769C16.0111 9.2769 8.3432 9.2769 0.564026 9.2769ZM2.91977 6.62082C2.89161 7.09948 3.26971 7.53523 3.75105 7.57948C4.22836 7.62238 4.66545 7.24697 4.70702 6.75892C4.75126 6.23468 4.36646 5.78552 3.85563 5.76407C3.38501 5.74262 2.94792 6.14351 2.91977 6.62082ZM7.8994 6.64898C7.88599 6.17032 7.46365 5.75737 6.99304 5.76139C6.48891 5.76541 6.08131 6.21457 6.11081 6.73211C6.13896 7.21345 6.57203 7.61032 7.04399 7.58484C7.51862 7.55937 7.91281 7.12898 7.8994 6.64898Z"
            />
            <path
              className="active-menu-class"
              d="M23.7695 14.6523C25.723 16.3297 27.9581 17.1395 30.5618 17.2467C30.5618 17.5001 30.5618 17.7334 30.5618 17.9667C30.5578 20.4579 30.5364 22.9477 30.5592 25.4389C30.5699 26.6161 30.1851 27.6136 29.4182 28.4797C27.9178 30.1758 25.9898 31.2873 24.043 32.3653C23.9009 32.4444 23.6367 32.431 23.4906 32.3506C21.694 31.3705 19.9255 30.3461 18.4479 28.8981C17.4464 27.9166 16.9329 26.7716 16.9664 25.3276C17.0254 22.7493 16.9852 20.1683 16.9878 17.59C16.9878 17.5042 17.0053 17.417 17.0227 17.2548C19.5273 17.1395 21.7985 16.3699 23.7695 14.6523ZM21.5089 25.2887C21.5599 25.3531 21.6095 25.4174 21.6604 25.4818C21.3346 25.1519 21.0115 24.8208 20.683 24.4923C20.3384 24.1477 19.955 24.0311 19.5755 24.4078C19.2269 24.7537 19.2967 25.1292 19.6171 25.4684C20.1051 25.9846 20.5892 26.5061 21.0906 27.0103C21.4942 27.4165 21.9165 27.3964 22.3094 26.9861C24.1704 25.046 26.0287 23.1032 27.8856 21.1591C28.2195 20.8105 28.3348 20.4096 27.942 20.049C27.5572 19.6963 27.167 19.821 26.8305 20.1723C26.0166 21.0237 25.2323 21.9046 24.3822 22.7184C23.4571 23.6074 22.4703 24.4346 21.5089 25.2887Z"
            />
            <path
              className="active-menu-class"
              d="M23.7146 10.4623C23.7146 11.3619 23.7146 12.2241 23.7146 13.0218C23.2882 13.3047 22.8739 13.5447 22.4998 13.8357C20.9981 15.0035 19.3128 15.6725 17.4049 15.7449C15.9944 15.7986 15.5519 16.2491 15.5332 17.6689C15.5144 19.1116 15.5144 19.1143 14.0945 19.1143C9.8657 19.1156 5.6369 19.1143 1.40944 19.113C1.14933 19.113 0.890557 19.0915 0.599609 19.0781C0.599609 16.1807 0.599609 13.3436 0.599609 10.4609C8.29699 10.4623 15.9662 10.4623 23.7146 10.4623ZM7.90012 16.4783C7.92158 15.9889 7.5475 15.5733 7.05678 15.5438C6.56605 15.5143 6.14505 15.8817 6.11153 16.3724C6.07667 16.89 6.47756 17.3431 6.98035 17.3539C7.44962 17.3632 7.87733 16.957 7.90012 16.4783ZM3.81881 17.3565C4.2921 17.3592 4.70238 16.9503 4.7131 16.4636C4.72383 15.9608 4.35512 15.5639 3.85903 15.5452C3.34149 15.5264 2.91513 15.9407 2.92317 16.4569C2.92987 16.9329 3.3482 17.3539 3.81881 17.3565Z"
            />
            <path
              className="active-menu-class"
              d="M0.570582 20.2656C5.58508 20.2656 10.5111 20.2656 15.5229 20.2656C15.5229 20.7496 15.5229 21.1881 15.5229 21.6279C15.5216 22.9619 15.5202 24.2973 15.5175 25.6314C15.5149 26.7965 15.8165 27.8718 16.5472 28.9016C16.3113 28.931 16.1517 28.9686 15.9922 28.9686C11.3209 28.9713 6.65099 28.9726 1.97974 28.9686C1.09885 28.9672 0.589353 28.5838 0.579968 27.8008C0.551812 25.3136 0.570582 22.8238 0.570582 20.2656ZM7.90059 26.0967C7.91534 25.6019 7.54395 25.2037 7.04384 25.1796C6.53971 25.1554 6.13748 25.5148 6.112 26.0122C6.08519 26.5337 6.48876 26.9762 6.99289 26.9816C7.4635 26.9856 7.88585 26.5753 7.90059 26.0967ZM4.71223 26.0832C4.71894 25.5805 4.34754 25.1916 3.84878 25.1782C3.34867 25.1648 2.94375 25.5335 2.92096 26.0256C2.89683 26.5257 3.33124 26.9829 3.82598 26.9816C4.30464 26.9789 4.70553 26.574 4.71223 26.0832Z"
            />
          </svg>
        </div>
      ),
      label: <h4 className="menu-lable">Privacy & Policy</h4>,
      onClick: () => {
        navigation("/privacyPolicy", {
          state: { headrTitle: "Privacy & Policy" },
        });
      },
    },
    {
      style: menuStyle,
      key: "Invite Friend",
      icon: (
        <div
          className="active-menu-class"
          style={{ padding: "10px", borderRadius: 5 }}
        >
          <IoPersonAddSharp size={25} className="active-menu-class" />
        </div>
      ),
      label: <h4 className="menu-lable">Invite Friend</h4>,
      onClick: () => {
        navigate("/inviteFriend");
      },
    },
    // {
    //   style: menuStyle,
    //   key: 'Settings',
    //   icon: (
    //     <div
    //       className="active-menu-class"
    //       style={{ padding: "10px", borderRadius: 5 }}
    //     >
    //       <SlSettings size={20} className="active-menu-class" />
    //     </div>
    //   ),
    //   label: <h4 className="menu-lable">{t("Settings")}</h4>,
    //   onClick: () => {
    //     // navigate("/Settings");
    //   },
    // },
  ];

  if (role == roles.client) {
    menu.splice(2, 1, {
      style: menuStyle,
      key: "Find Vendors",
      icon: (
        <div
          className="active-menu-class"
          style={{ padding: "10px", borderRadius: 5 }}
        >
          <svg
            width="21"
            height="23"
            viewBox="0 0 31 31"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              className="active-menu-class"
              d="M2.19141 20.5762C11.1527 20.5762 20.0417 20.5762 28.9995 20.5762C29.0127 20.7837 29.0356 20.9744 29.0356 21.1639C29.038 24.0264 29.038 26.889 29.0368 29.7527C29.0368 30.5227 29.0019 30.554 28.2126 30.554C19.8176 30.5553 11.4214 30.5553 3.02645 30.554C2.19743 30.554 2.19141 30.5468 2.19141 29.7117C2.19141 26.8685 2.19141 24.0264 2.19141 21.1832C2.19141 21.0046 2.19141 20.8272 2.19141 20.5762ZM15.628 22.2741C13.7687 22.2741 11.9082 22.2826 10.049 22.2669C9.63447 22.2633 9.39589 22.3429 9.28503 22.8076C9.22117 23.0767 8.94523 23.4665 8.72231 23.4966C7.94029 23.604 7.95596 24.1025 7.9897 24.6685C8.00657 24.9484 7.99933 25.2296 7.99211 25.5096C7.98247 25.8342 8.09091 26.0502 8.44397 26.0937C8.94403 26.1564 9.24045 26.4569 9.31998 26.9421C9.38022 27.3138 9.57302 27.432 9.9333 27.4308C13.7121 27.4224 17.492 27.4224 21.2708 27.4296C21.654 27.4308 21.8143 27.2969 21.9191 26.9047C21.995 26.6187 22.2842 26.2168 22.5264 26.1794C23.1975 26.0756 23.2554 25.6954 23.2144 25.1657C23.1915 24.8676 23.1963 24.5647 23.2144 24.2654C23.2385 23.8695 23.124 23.6801 22.6903 23.5606C22.3854 23.4773 22.0034 23.131 21.9384 22.8389C21.8239 22.3272 21.5757 22.2645 21.1467 22.2669C19.3079 22.2826 17.4679 22.2741 15.628 22.2741Z"
            />
            <path
              className="active-menu-class"
              d="M15.6074 19.7645C10.89 19.7645 6.17256 19.7645 1.45512 19.7645C0.653823 19.7645 0.649003 19.7585 0.647798 18.962C0.646593 18.3019 0.674307 17.6393 0.639363 16.9804C0.610444 16.4289 0.816493 16.2515 1.36716 16.2539C5.26522 16.272 9.16328 16.2636 13.0613 16.2636C18.6379 16.2636 24.2157 16.2636 29.7923 16.2636C30.6225 16.2636 30.6225 16.2636 30.6237 17.0963C30.6249 17.7371 30.5948 18.3791 30.6321 19.0175C30.6659 19.592 30.461 19.7778 29.879 19.7754C25.123 19.7561 20.3658 19.7645 15.6074 19.7645Z"
            />
            <path
              className="active-menu-class"
              d="M17.5451 15.5255C12.4951 15.5255 7.65957 15.5255 2.77344 15.5255C2.79151 14.6566 3.14577 13.9397 3.65668 13.2953C4.64716 12.045 5.97382 11.2872 7.46798 10.8129C7.64149 10.7574 7.97406 10.8877 8.09577 11.0398C9.05974 12.243 11.0744 12.2224 12.0625 10.9939C12.1685 10.8624 12.4541 10.7453 12.5963 10.7948C14.229 11.356 15.7389 12.1331 16.7028 13.6416C17.0487 14.1823 17.2378 14.8231 17.5451 15.5255Z"
            />
            <path
              className="active-menu-class"
              d="M19.371 7.04731C22.9112 7.04731 26.3779 7.04731 29.9036 7.04731C29.9036 5.71137 29.9036 4.41405 29.9036 3.11794C29.9036 2.41679 29.8831 1.71564 29.9205 1.01689C29.9289 0.857596 30.1338 0.707952 30.2482 0.554688C30.3506 0.701918 30.5085 0.835873 30.5446 0.997585C30.5965 1.22688 30.5591 1.47548 30.5591 1.71564C30.5591 5.67879 30.5483 9.64315 30.5712 13.6063C30.5748 14.2121 30.3928 14.3968 29.7867 14.3931C26.349 14.3678 22.9112 14.3714 19.4734 14.3919C18.9095 14.3955 18.7035 14.2326 18.7071 13.6461C18.7264 9.50195 18.7167 5.35898 18.7179 1.21481C18.7179 1.07482 18.6986 0.919143 18.7553 0.800876C18.8059 0.694677 18.9469 0.567962 19.0469 0.567962C19.1493 0.569169 19.3047 0.695884 19.3397 0.799669C19.3939 0.963795 19.371 1.15568 19.371 1.33549C19.3722 3.2169 19.371 5.09711 19.371 7.04731ZM29.8012 13.628C29.8012 11.6597 29.8012 9.76624 29.8012 7.85225C26.3176 7.85225 22.8738 7.85225 19.4204 7.85225C19.4204 9.80244 19.4204 11.7092 19.4204 13.628C22.8991 13.628 26.3297 13.628 29.8012 13.628Z"
            />
            <path
              className="active-menu-class"
              d="M6.30397 6.28068C8.03791 6.85029 9.60075 6.35912 11.1359 5.75571C11.5142 5.60728 11.7733 5.60848 12.1071 5.84864C12.6264 6.22154 13.1783 6.58962 13.8952 6.26861C14.082 6.81891 13.9471 7.25457 13.6205 7.68057C13.3723 8.0052 13.1385 8.35638 12.9795 8.72929C12.3951 10.099 11.3516 10.8702 10.0623 10.8352C8.50544 10.7929 7.52098 10.0351 7.01249 8.50723C6.95344 8.32863 6.85705 8.13192 6.71727 8.01365C6.16419 7.54179 6.13889 6.96493 6.30397 6.28068Z"
            />
            <path
              className="active-menu-class"
              d="M6.48055 4.62193C6.38656 2.49192 7.96627 1.04617 10.0906 1.40942C10.9028 1.5482 11.7065 1.85111 12.4584 2.19987C13.4416 2.65725 14.0477 4.5278 13.5694 5.46549C13.5115 5.57773 13.1934 5.65255 13.044 5.60186C12.7681 5.50652 12.4777 5.35326 12.2825 5.14086C11.8402 4.65693 11.4378 4.84761 10.9172 5.01656C9.88457 5.35205 8.81938 5.65979 7.74576 5.77926C6.61309 5.90477 6.52874 5.73461 6.48055 4.62193Z"
            />
            <path
              className="active-menu-class"
              d="M29.0362 6.38764C27.7072 6.38764 26.4154 6.38764 25.1056 6.38764C24.8815 5.09032 24.9779 3.83041 25.7479 2.77205C26.2708 2.054 27.1637 2.56568 27.8831 2.48241C28.0626 2.4619 28.3374 2.72981 28.4699 2.93014C29.1615 3.9692 29.164 5.1398 29.0362 6.38764Z"
            />
            <path
              className="active-menu-class"
              d="M20.1966 6.36991C20.0822 5.1281 20.0641 3.94905 20.775 2.91361C20.9172 2.70604 21.2124 2.59864 21.4474 2.46227C21.5076 2.42727 21.6052 2.4502 21.6836 2.45744C22.2475 2.50813 23.0681 2.35003 23.3211 2.65898C23.8248 3.27083 24.2284 4.06249 24.1513 4.96518C24.1128 5.41774 24.1441 5.87632 24.1441 6.36991C22.8066 6.36991 21.5209 6.36991 20.1966 6.36991Z"
            />
            <path
              className="active-menu-class"
              d="M20.8368 1.68583C20.8007 0.897786 20.8477 0.844687 21.567 0.838653C21.9671 0.835032 22.3659 0.835032 22.766 0.838653C23.4974 0.844687 23.5395 0.892959 23.4733 1.68583C22.5973 1.68583 21.7164 1.68583 20.8368 1.68583Z"
            />
            <path
              className="active-menu-class"
              d="M28.4354 1.7023C27.5425 1.7023 26.6918 1.7023 25.8423 1.7023C25.6869 0.955283 25.7737 0.844256 26.5087 0.838222C26.9075 0.834602 27.3076 0.835809 27.7064 0.838222C28.4427 0.844256 28.4764 0.882874 28.4354 1.7023Z"
            />
            <path
              className="active-menu-class"
              d="M10.2909 26.6916C9.75345 26.2052 9.37027 25.819 8.94612 25.486C8.61837 25.2277 8.62681 24.3974 8.97625 24.1717C9.25459 23.9907 9.63175 23.8049 9.73176 23.5345C9.95468 22.9324 10.3692 22.948 10.8644 22.9505C14.1046 22.9613 17.3435 22.9613 20.5837 22.9492C20.9909 22.948 21.2825 22.9818 21.4717 23.4308C21.5838 23.6975 21.8742 23.9666 22.1477 24.0692C22.5875 24.2357 22.5429 24.5386 22.5622 24.8789C22.5803 25.2144 22.4598 25.3785 22.1622 25.5716C21.7645 25.8299 21.4693 26.2462 21.0367 26.6916C17.4941 26.6916 13.7768 26.6916 10.2909 26.6916Z"
            />
            <path
              className="active-menu-class"
              d="M24.1403 12.8653C22.8751 12.8653 21.6677 12.8653 20.4037 12.8653C20.4037 12.2402 20.3724 11.6428 20.4254 11.0527C20.4387 10.9006 20.7098 10.6569 20.8712 10.6496C21.7882 10.611 22.71 10.6062 23.627 10.652C23.8053 10.6617 24.0981 10.9344 24.1174 11.1106C24.1801 11.6802 24.1403 12.2595 24.1403 12.8653Z"
            />
            <path
              className="active-menu-class"
              d="M28.9409 12.873C27.6648 12.873 26.4731 12.873 25.2067 12.873C25.2067 12.2383 25.1802 11.6252 25.2272 11.017C25.238 10.8782 25.4959 10.6537 25.6465 10.6489C26.5647 10.6139 27.4853 10.603 28.4022 10.6537C28.5902 10.6646 28.8927 10.9554 28.918 11.1461C28.9866 11.694 28.9409 12.2576 28.9409 12.873Z"
            />
          </svg>
        </div>
      ),
      label: <h4 className="menu-lable">Vendors</h4>,
      onClick: () => {
        navigation("/findVendors");
      },
    });
    // menu.splice(2, 1)
    // menu.splice(2, 1)
    menu.splice(
      4,
      0,

      {
        style: menuStyle,
        key: "Review Response",
        icon: (
          <div
            className="active-menu-class"
            style={{ padding: "10px", borderRadius: 5 }}
          >
            <GiStarsStack size={25} className="active-menu-class" />
          </div>
        ),
        label: <h4 className="menu-lable">Review Response</h4>,
        onClick: () => {
          navigation("/reviewResponse");
        },
      }
    );
    // menu.splice(5, 1);
    menu.splice(6, 1);
  }
  if (role == roles.vendor) {
    menu.splice(4, 0, {
      style: menuStyle,
      key: "Song Ideas",
      icon: (
        <div
          className="active-menu-class"
          style={{ padding: "10px", borderRadius: 5 }}
        >

          <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="21"
            height="23" viewBox="0 0 128 128">
            <path d="M 33.900391 24 C 32.300391 24 31 25.4 31 27 L 31 58.199219 C 31 58.999219 30.2 59.4 29.5 59 C 26.8 57.4 23.499609 56.699609 20.099609 57.099609 C 13.199609 57.999609 7.7996094 63.600391 7.0996094 70.400391 C 6.0996094 79.800391 13.799609 87.6 23.099609 87 C 30.999609 86.4 37 79.499609 37 71.599609 L 37 30.5 C 40.5 31.7 43 35.000391 43 38.900391 C 43 40.100391 43.700391 41.299219 44.900391 41.699219 C 47.000391 42.599219 49 41 49 39 C 49 30.7 42.200391 23.9 33.900391 24 z M 108.68359 36.244141 C 107.85547 36.262891 107.02422 36.35 106.19922 36.5 L 76.5 42.400391 C 70.4 43.700391 66 48.999219 66 55.199219 L 66 88.199219 C 66 88.999219 65.2 89.4 64.5 89 C 61.8 87.4 58.499609 86.699609 55.099609 87.099609 C 48.299609 87.999609 42.799609 93.500391 42.099609 100.40039 C 41.099609 109.80039 48.799609 117.6 58.099609 117 C 65.999609 116.4 72 109.59922 72 101.69922 L 72 69.5 L 116 60.699219 L 116 78.199219 C 116 78.999219 115.2 79.4 114.5 79 C 111.8 77.4 108.49961 76.699609 105.09961 77.099609 C 98.299609 77.999609 92.799609 83.500391 92.099609 90.400391 C 91.099609 99.800391 98.799609 107.6 108.09961 107 C 115.99961 106.4 122 99.599219 122 91.699219 L 122 49.199219 C 122 44.699219 119.70078 40.499609 115.80078 38.099609 C 113.62578 36.749609 111.16797 36.187891 108.68359 36.244141 z M 109.16797 42.167969 C 110.71953 42.205469 112.20039 42.750781 113.40039 43.800781 C 115.00039 45.100781 116 47.099219 116 49.199219 L 116 54.5 L 72 63.300781 L 72 55.199219 C 72 51.899219 74.399609 49.000781 77.599609 48.300781 L 107.59961 42.300781 C 108.12461 42.200781 108.65078 42.155469 109.16797 42.167969 z M 22 63 C 27 63 31 67 31 72 C 31 77 27 81 22 81 C 17 81 13 77 13 72 C 13 67 17 63 22 63 z M 107 83 C 112 83 116 87 116 92 C 116 97 112 101 107 101 C 102 101 98 97 98 92 C 98 87 102 83 107 83 z M 57 93 C 62 93 66 97 66 102 C 66 107 62 111 57 111 C 52 111 48 107 48 102 C 48 97 52 93 57 93 z"></path>
          </svg>

          
        </div>
      ),
      label: <h4 className="menu-lable">Song Ideas</h4>,
      onClick: () => {
        navigation("/songIdeas");
      },
    });

    // menu.splice(6, 1);
  }

  if (role == roles.guest) {
    menu.splice(2, 2);
    menu.splice(3, 1)
  }
  if (role == roles.coHost) {
    menu.splice(2, 4);
    menu.splice(0, 1);
  }

  if (role == roles.staff) {
    menu.splice(2, 1);
    menu.splice(3, 1);
  }

  return (
    <div className="menu-main-container">
      <div className="logo_container">
        {collapsed ? (
          <img
            src={require("../../assets/logoSideMenu.png")}
            alt="logo"
            style={{ width: "50%", height: "50%" }}
          />
        ) : (
          <img
            src={require("../../assets/logoSideMenu.png")}
            alt="logo"
            style={{ width: "70%", height: "70%" }}
          />
        )}
      </div>
      <Menu
        _internalDisableMenuItemTitleTooltip
        className={`${collapsed ? "menu-colapsed" : "menu"}`}
        mode="inline"
        defaultSelectedKeys={location.pathname}
        selectedKeys={checkRouteName(location.pathname?.substring(1))}
        items={menu}
      />
      {role != roles.coHost && (
        <div
          style={{
            backgroundColor: "#60708F",
          }}
          className={`menu-logout ${collapsed ? "colapsedClass" : ""}`}
          onClick={() => {
            navigation("/inbox");
          }}
        >
          <PiChats size={40} className="chatIcon" />
          {width > 768 && !collapsed ? (
            <h3 style={{ color: "var(--white-color)" }}>Chat</h3>
          ) : null}
        </div>
      )}
      {/* {!collapsed ? ( */}
      <div
        className={`menu-logout ${collapsed ? "colapsedClass" : ""}`}
        onClick={logout}
      >
        <MdOutlineLogout size={40} className="logoutIcon" />
        {width > 768 && !collapsed ? <h3>Log Out</h3> : null}
      </div>
    </div>
  );
}

export default SideMenu;
